import { render, staticRenderFns } from "./PrefectureGoods.vue?vue&type=template&id=de5f9882&scoped=true"
import script from "./PrefectureGoods.vue?vue&type=script&lang=js"
export * from "./PrefectureGoods.vue?vue&type=script&lang=js"
import style0 from "./PrefectureGoods.vue?vue&type=style&index=0&id=de5f9882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5f9882",
  null
  
)

export default component.exports